import http from './../../base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 共通住所ポップ页面列表
export const dialogApi = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_AddressData + '?' + querys)
}


// WEBPACK FOOTER //
// ./src/components/api/dialogAddress.js